// Configure a backend proxy, never a provider key in the browser bundle.
export const assistantEndpoint = process.env.REACT_APP_ASSISTANT_API_URL || '';

export async function requestAssistant(messages, language, signal, endpoint = assistantEndpoint) {
  if (!endpoint.startsWith('/') || endpoint.startsWith('//')) throw new Error('A same-origin backend endpoint is required.');
  const controller = new AbortController();
  const abort = () => controller.abort();
  if (signal?.aborted) controller.abort();
  signal?.addEventListener('abort', abort, { once: true });
  const timeout = setTimeout(abort, 15000);
  try {
    const response = await fetch(endpoint, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, signal: controller.signal,
      body: JSON.stringify({ language, messages: messages.slice(-12).map(({ role, content }) => ({ role, content })) }),
    });
    if (!response.ok) throw new Error('Assistant unavailable.');
    const data = await response.json();
    if (typeof data.reply !== 'string' || !data.reply.trim() || data.reply.length > 6000) throw new Error('Invalid assistant response.');
    return data.reply.trim();
  } finally {
    clearTimeout(timeout);
    signal?.removeEventListener('abort', abort);
  }
}

export function localAnswer(question) {
  const text = question.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  if (/precio|costo|cuanto|cost|price|preis|cout|tarif|价格|费用|стоим|цен/.test(text)) return 'pricing';
  if (/cita|reunion|agend|appointment|meeting|termin|rendez|预约|встреч|запис/.test(text)) return 'appointment';
  if (/soporte|support|repair|repar|hilfe|维护|支持|поддерж|ремонт/.test(text)) return 'support';
  if (/persona|humano|human|person|contact|联系|人工|человек|связ/.test(text)) return 'human';
  if (/servici|service|servic|leistung|服务|услуг|automat|\bia\b|\bai\b|integra|cloud|web|software|redes|network|人工智能|自动|интегр|сайт/.test(text)) return 'services';
  if (/^(hola|hello|hi|bonjour|salut|hallo|你好|привет|здравствуйте)[! .?]*$/.test(text.trim())) return 'greeting';
  return 'unknown';
}
